import { AxiosError } from 'axios';
import instance from '../config/axios';

export const createLabel = async (accessToken: string, orderId: number) => {
  try {
    const response = await instance({
      url: `/api/v1/label/create/${orderId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return { status: response.status, data: response.data };
  } catch (e) {
    console.log(e);
    const error = e as AxiosError;
    return {
      status: error.response?.status,
      data: (error.response?.data as { message: string }).message,
    };
  }
};
